const initialState = {
  maxNumber: 90, //1-100
  numbers: [], //actual numbers remaining
  history: [], //history of past number
  animation: true, //true or false, enable or disable animation
  animationDuration: 4000, //ms (4sc) (2000-6000) (2s-6s), edit animation duration
  sound: false, //true or false, enable or disable sound
  isFinish: false, //true or false, true if game is finish
  autoplay: false, //true or false, enable or disable autoplay
  interval: 5000, //ms (5s) (5000-120000) (5s-2min), edit autoplay interval
  needToReload: false, //true or false, true if need to reload game
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case INITIALIZE_GAME:
    case RESET_GAME:
      return {
        ...state,
        numbers: Array.from({ length: state.maxNumber }, (_, i) => i + 1),
        history: [],
        isFinish: false,
        needToReload: false,
      };

    case PLAY_GAME: {
      const drawn = state.numbers[action.payload];
      if (drawn === undefined) {
        return state;
      }
      const numbers = state.numbers.filter((_, i) => i !== action.payload);
      return {
        ...state,
        numbers,
        history: [drawn, ...state.history],
        isFinish: numbers.length === 0,
      };
    }

    case CHANGE_MAX_NUMBER:
      if (action.payload >= 10 && action.payload <= 100) {
        return { ...state, maxNumber: action.payload, needToReload: true };
      }
      return state;

    case CHANGE_ANIMATION:
      return { ...state, animation: action.payload };

    case CHANGE_ANIMATION_DURATION:
      return { ...state, animationDuration: action.payload };

    case CHANGE_SOUND:
      return { ...state, sound: action.payload };

    case CHANGE_AUTOPLAY:
      return { ...state, autoplay: action.payload, needToReload: true };

    case CHANGE_INTERVAL:
      return { ...state, interval: action.payload };

    default:
      return state;
  }
};

export const INITIALIZE_GAME = "INITIALIZE_GAME";
export const PLAY_GAME = "PLAY_GAME";
export const RESET_GAME = "RESET_GAME";
export const CHANGE_MAX_NUMBER = "CHANGE_MAX_NUMBER";
export const CHANGE_ANIMATION = "CHANGE_ANIMATION";
export const CHANGE_ANIMATION_DURATION = "CHANGE_ANIMATION_DURATION";
export const CHANGE_SOUND = "CHANGE_SOUND";
export const CHANGE_AUTOPLAY = "CHANGE_AUTOPLAY";
export const CHANGE_INTERVAL = "CHANGE_INTERVAL";
export default reducer;
